import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMenuStore } from '../zustand/store/useMenuStore';
import { useShallow } from 'zustand/shallow';
import HomeProfile from '../contents/home/HomeProfile';
import TopMenu from './TopMenu';
import MenuList from './MenuList';
import Favorite from './Favorite';
import Navi from './Navi';
import useQueryLinkNavigate from '../hooks/useQueryLinkNavigate';

import '../css/side-bar.css';
import { useDynamicStyle } from '../hooks/useDynamicStyle';
import { useSubIcon } from '../hooks/useSubIcon';
import * as Icons from '../images/icons/icons_component';

function LeftSidebar({ isSidebarToggle, sidebarRef, handleSmallMoniterMenuClick }) {
    
    const { isHome } = useQueryLinkNavigate();
    const navigation = useNavigate();

    const [ menuData, collapsed, clickedCategory ] = useMenuStore(useShallow((state) => [state.menuData, state.collapsed, state.clickedCategory]));
    const { checkedTopCode } = useMenuStore((state) => state.currentInfo);
    
    const topMenu = menuData[clickedCategory] || [];
    const menuTree = topMenu?.menuTree;
    
    // Dynamic Style Hook
    const { lightBorderShadowColor } = useDynamicStyle();

    // icon list
    const { graySubIcon, whiteSubIcon, hoverSubIcon } = useSubIcon();
    
    // favorite
    const [favMenuOpen, setFavMenuOpen] = useState(false);
    const homeRef = useRef(null);
    const favBtnRef = useRef(null);
    const favMenuRef = useRef(null);
    const nextRef = useRef(null);

    return (
        <React.Fragment>
            <div ref={sidebarRef} className={`sidebar_container ${isHome ? 'sidebar_container_home_media_set' : 'sidebar_container_media_set ' + lightBorderShadowColor}`}>
                <div className={isHome ? 'home_profile_container' : `sidebar_wrapper ${isSidebarToggle ? '' : 'close_width'}`}>
                    {isHome ? <HomeProfile /> :
                        <button title='home으로 이동' className={`home_button_wrapper ${isSidebarToggle ? '' : 'close_min_width'}`} onClick={() => {navigation('/'); handleSmallMoniterMenuClick();}}>
                            {isSidebarToggle ? <Icons.LogoIcoOpen /> : <Icons.LogoIcoClose className='close_logo_media_set' />}
                        </button>
                    }
                    <TopMenu isSidebarToggle={isSidebarToggle} />
                    {isHome ? '' :
                        <div className={`sidebar_scroll ${isSidebarToggle ? 'sidebar_w_media_set px-1' : 'flex justify-center'}`}>
                            <ul>
                            {menuTree && menuTree.map((menu, idx) => {
                                const isActive = collapsed === menu.MENUFLAG;
                                const goBackAction = checkedTopCode === menu.MENUFLAG;
                                const notMenu = typeof(menu.MENUSORC) === 'number' && menu.subMenu.length < 1;
                                return ( !notMenu &&
                                    <MenuList
                                        key={menu.MENUFLAG} 
                                        topList={menu.subMenu.length > 0 ? undefined : menu}
                                        subList={menu.subMenu}
                                        title={menu.MENUNAME}
                                        topMenuCode={menu.MENUFLAG}
                                        isSidebarToggle={isSidebarToggle}
                                        $isActive={isActive}
                                        $goBackAction={goBackAction}
                                        graySubIcon={graySubIcon[idx]}
                                        whiteSubIcon={whiteSubIcon[idx]}
                                        hoverSubIcon={hoverSubIcon[idx]}
                                        handleSmallMoniterMenuClick={handleSmallMoniterMenuClick}
                                    />
                                )
                            })}
                            </ul>
                        </div>
                    }
                    {favMenuOpen || isHome ?
                        <Favorite
                            isSidebarToggle={isSidebarToggle}
                            favMenuOpen={favMenuOpen}
                            setFavMenuOpen={setFavMenuOpen}
                            homeRef={homeRef}
                            favMenuRef={favMenuRef}
                            favBtnRef={favBtnRef}
                            nextRef={nextRef}
                            handleSmallMoniterMenuClick={handleSmallMoniterMenuClick}
                        />
                    : ''}
                    <Navi
                        isSidebarToggle={isSidebarToggle}
                        favMenuOpen={favMenuOpen}
                        setFavMenuOpen={setFavMenuOpen}
                        homeRef={homeRef}
                        favMenuRef={favMenuRef}
                        favBtnRef={favBtnRef}
                        nextRef={nextRef}
                        handleSmallMoniterMenuClick={handleSmallMoniterMenuClick}
                    />
                </div>
            </div>
        </React.Fragment>
    )
}

export default LeftSidebar